import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

type OptionLabels = {
  main: string;
};

type IProps = {
  exists: boolean | undefined;
  value?: string[];
  options: Record<string, OptionLabels>;
  description?: string;
};

export const AIToolsDisplay: React.FC<IProps> = ({
  exists,
  value = [],
  options,
  description = ''
}) => {
  const displayValues = value.map(v => options[v]?.main || v).filter(Boolean);

  return (
    <Flex flexDirection="column">
      <Text textStyle="textBody">
        {exists === true ? 'Yes' : exists === false ? 'No' : '—'}
      </Text>
      {exists && displayValues.length > 0 && (
        <Box>
          <Text textStyle="textBody">
            <strong>Used Tools:</strong> {displayValues.join(', ')}
          </Text>

          <Text textStyle="textBody">
            <strong>Acknowledgement:</strong> {description}
          </Text>
        </Box>
      )}
    </Flex>
  );
};
